
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"22","cy":"22","r":"22","fill":"var(--status-svg-color)"}}),_c('path',{attrs:{"stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M33.857 28.158v3.45a2.307 2.307 0 01-.74 1.704 2.277 2.277 0 01-1.751.596 22.527 22.527 0 01-9.863-3.53 22.356 22.356 0 01-6.857-6.9 22.85 22.85 0 01-3.509-9.971 2.309 2.309 0 01.588-1.758A2.28 2.28 0 0113.411 11h3.429a2.29 2.29 0 012.286 1.978 14.81 14.81 0 00.8 3.232 2.31 2.31 0 01-.515 2.426l-1.451 1.46a18.343 18.343 0 006.857 6.9l1.452-1.46a2.275 2.275 0 012.411-.518 14.6 14.6 0 003.211.805 2.296 2.296 0 011.966 2.335z"}}),_c('g',{attrs:{"fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M29.73 19l1.27-.222a5.843 5.843 0 00-1.586-3.129A5.601 5.601 0 0026.179 14L26 15.305c.953.137 1.82.576 2.505 1.276A4.508 4.508 0 0129.73 19z"}}),_c('path',{attrs:{"d":"M31.423 13.685A9.07 9.07 0 0026.175 11L26 12.28a7.864 7.864 0 014.535 2.32 8.209 8.209 0 012.224 4.4L34 18.783a9.544 9.544 0 00-2.577-5.098z"}})])])])
          )
        }
      }
    